module.exports = __webpack_public_path__ + "static/media/final-logo.bb881f94.jpg";